import { el } from 'redom';
import Element from './Element';

export default class Span extends Element {
  constructor(elementParent, attrs) {
    super(attrs);
    
    this.rootElement = el('span');

    if(attrs) {
      this.setAttrs(attrs);
    }

    if (elementParent) {
      elementParent.addChild(this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/AAF/lib/gui/dom/Span.js